export default __webpack_public_path__ + "static/media/decada-0060-0003-min.97de0ade.jpg";